'use client'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { PricingRuleModel } from '@marketplace-web/domain/escrow-pricing-data'

import PriceRuleTitle from './PricingRuleTitle'

type Props = {
  priceRule: PricingRuleModel
}

const PriceRuleSection = ({ priceRule }: Props) => {
  const translate = useTranslate('available_discounts')

  const priceRuleData = [
    {
      label: translate('price_rule_data.label.promotion_period'),
      value: 'date',
    },
  ]

  return (
    <section className="available_discounts__price-rule-section">
      <PriceRuleTitle priceRule={priceRule} />
      <div className="available_discounts__price-rule-subtitle">
        {translate('targeted_campaign_note')}
      </div>
      <div className="available_discounts__price-rule-card">
        <h3 className="available_discounts__pricing-rule-card-title">
          {translate('discount_terms_label')}
        </h3>
        {priceRuleData.map(data => (
          <div key={data.label} className="available_discounts__pricing-rule-card-data-wrapper">
            <div className="available_discounts__pricing-rule-card-data">
              <div className="available_discounts__pricing-rule-card-data-label">{data.label}</div>
              <div className="available_discounts__pricing-rule-card-data-value">{data.value}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default PriceRuleSection
